/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Intro_P1_AfterInputs */

const es_exp_mk_intro_p1_after = /** @type {(inputs: Exp_Mk_Intro_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` conecta a quien quiere navegar con quien tiene un barco disponible. Es compartir gastos, no alquilar: accesible, social y sin necesidad de ningún trámite.`)
};

const gl_exp_mk_intro_p1_after = /** @type {(inputs: Exp_Mk_Intro_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` conecta a quen quere navegar con quen ten un barco dispoñible. É compartir gastos, non alugar: accesible, social e sen ningún trámite.`)
};

const en_exp_mk_intro_p1_after = /** @type {(inputs: Exp_Mk_Intro_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` connects people who want to sail with those who have a boat available. It is cost-sharing, not rental: accessible, social and no paperwork required.`)
};

/**
* | output |
* | --- |
* | "connects people who want to sail with those who have a boat available. It is cost-sharing, not rental: accessible, social and no paperwork required." |
*
* @param {Exp_Mk_Intro_P1_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_intro_p1_after = /** @type {((inputs?: Exp_Mk_Intro_P1_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Intro_P1_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_intro_p1_after(inputs)
	if (locale === "en") return en_exp_mk_intro_p1_after(inputs)
	return es_exp_mk_intro_p1_after(inputs)
});